/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TransPb } from "../body/trans";
import { Vector3dPb } from "../eigen_lcm/Vector3d";

export const protobufPackage = "shape_map";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface CylinderPb {
  add: boolean;
  center: Vector3dPb | undefined;
  radius: number;
  height: number;
  trans: TransPb | undefined;
}

function createBaseCylinderPb(): CylinderPb {
  return { add: false, center: undefined, radius: 0, height: 0, trans: undefined };
}

export const CylinderPb = {
  encode(message: CylinderPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.add === true) {
      writer.uint32(8).bool(message.add);
    }
    if (message.center !== undefined) {
      Vector3dPb.encode(message.center, writer.uint32(18).fork()).ldelim();
    }
    if (message.radius !== 0) {
      writer.uint32(25).double(message.radius);
    }
    if (message.height !== 0) {
      writer.uint32(33).double(message.height);
    }
    if (message.trans !== undefined) {
      TransPb.encode(message.trans, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CylinderPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCylinderPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.add = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.center = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.radius = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.height = reader.double();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.trans = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CylinderPb {
    return {
      add: isSet(object.add) ? globalThis.Boolean(object.add) : false,
      center: isSet(object.center) ? Vector3dPb.fromJSON(object.center) : undefined,
      radius: isSet(object.radius) ? globalThis.Number(object.radius) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      trans: isSet(object.trans) ? TransPb.fromJSON(object.trans) : undefined,
    };
  },

  toJSON(message: CylinderPb): unknown {
    const obj: any = {};
    if (message.add === true) {
      obj.add = message.add;
    }
    if (message.center !== undefined) {
      obj.center = Vector3dPb.toJSON(message.center);
    }
    if (message.radius !== 0) {
      obj.radius = message.radius;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.trans !== undefined) {
      obj.trans = TransPb.toJSON(message.trans);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CylinderPb>, I>>(base?: I): CylinderPb {
    return CylinderPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CylinderPb>, I>>(object: I): CylinderPb {
    const message = createBaseCylinderPb();
    message.add = object.add ?? false;
    message.center = (object.center !== undefined && object.center !== null)
      ? Vector3dPb.fromPartial(object.center)
      : undefined;
    message.radius = object.radius ?? 0;
    message.height = object.height ?? 0;
    message.trans = (object.trans !== undefined && object.trans !== null)
      ? TransPb.fromPartial(object.trans)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
